export interface GeocodeResult {
  lat: string
  lon: string
  displayName: string
}

export async function geocodeQuery(query: string): Promise<GeocodeResult | null> {
  const params = new URLSearchParams({
    q: query,
    format: 'json',
    limit: '1',
    countrycodes: 'us',
  })
  const resp = await fetch(
    `https://nominatim.openstreetmap.org/search?${params}`,
    { headers: { 'User-Agent': 'FCC-License-Manager/1.0', 'Accept-Language': 'en' } }
  )
  if (!resp.ok) throw new Error(`Geocoding request failed (${resp.status})`)
  const data = await resp.json()
  if (!Array.isArray(data) || data.length === 0) return null
  return {
    lat: parseFloat(data[0].lat).toFixed(6),
    lon: parseFloat(data[0].lon).toFixed(6),
    displayName: data[0].display_name as string,
  }
}
